import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { AuthClient } from 'app/auth/auth.client';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'change-password',
    templateUrl: 'change-password.component.html',
    styleUrls: ['change-password.component.scss'],
  host: {class: 'bmc-change-password'}
})
export class ChangePasswordComponent {
    public code: string;
    public userName = '';
    public password = '';
    public verificationPassword = '';
    public PASSWORD_REGEX = /^.*(?=.*\d)(?=.*[A-Za-z])(?=.{6,}).*$/g;

    private listTimeOut: any[] = [];

    @ViewChild('changePasswordForm', { static: false}) changePasswordForm: NgForm;

    constructor(private _route: ActivatedRoute,
        private _router: Router,
        private _autoLoginClient: AutoLoginClient,
        private _authClient: AuthClient,
        private _toastService: BzgToastService,
        private _translateService: TranslateService) {

         }

    ngOnInit() {
        this._route.queryParams.subscribe((params) => {
            this.code = params['verificationToken'];
        });
    }

    ngOnDestroy(): void {
      this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
    }

    public changePassword() {
        if(!this.isPasswordInvalid()) {
            if(!this.code){
                this._router.navigate(['login']);
            }
            this._autoLoginClient.changePasword(this.password, this.code)
                .subscribe((response) => {
                    switch (response) {
                        case 'ChangePasswordSuccessful':
                            this._translateService.get('AUTOADMIN.PASSWORD_SUCCESSFULLY_CHANGED').subscribe((message: string) => {
                                const toastDuration = 5000;
                                this._toastService.open(
                                    message,
                                    {
                                        type: 'success',
                                        duration: toastDuration,
                                        verticalPosition: 'bottom',
                                        horizontalPosition: 'right',
                                    });
                                this.listTimeOut.push(setTimeout(() => {
                                    this._router.navigate(['login']);
                                 }, toastDuration));
                            });
                            break;
                        case 'ValidateVerificationWrongCode':
                            this._translateService.get('AUTOADMIN.LINK_HAS_EXPIRED').subscribe((message: string) => {
                                this._toastService.open(
                                    message,
                                    {
                                        type: 'error',
                                        duration: 0,
                                        verticalPosition: 'bottom',
                                        horizontalPosition: 'right'
                                    });
                            });
                            break
                        case 'ChangePasswordUserNotFound':
                        case 'ChangePasswordUnexpectedError':
                        case 'ValidateVerificationCodeUnexpectedError':
                        default:
                            this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                                this._toastService.open(
                                    message,
                                    {
                                        type: 'error',
                                        duration: 0,
                                        verticalPosition: 'bottom',
                                        horizontalPosition: 'right'
                                    });
                            });
                            break
                    }
            });
        }
    }

    public testRegEx() {
        const result = this.PASSWORD_REGEX.test(this.password);
        this.PASSWORD_REGEX.lastIndex= 0;
        return result;

    }

    public isPasswordInvalid(): boolean {
        return !this.testRegEx() || this.password === '' || this.verificationPassword === '' || this.verificationPassword !== this.password;
    }
}
